(() => {
  const key = 'gg-optis-cart-locale';
  const script = document.currentScript;
  if (!script) return;
  const cartPath = script.dataset.cartUrl;
  if (!cartPath || !/^\/[a-z]{2}(?:-[a-z]{2})?\/cart\/?$/i.test(cartPath)) {
    if (location.pathname === '/cart' || location.pathname === '/cart/') {
      try {
        const raw = sessionStorage.getItem(key);
        sessionStorage.removeItem(key);
        const pending = raw && JSON.parse(raw);
        if (!pending || Date.now() - pending.time < 0 || Date.now() - pending.time > 120000) return;
        if (!/^\/[a-z]{2}(?:-[a-z]{2})?\/cart\/?$/i.test(pending.cartPath)) return;
        const previous = new URL(document.referrer);
        if (previous.origin !== location.origin || previous.pathname !== pending.source) return;
        location.replace(pending.cartPath + location.search + location.hash);
      } catch (_) {}
    }
    return;
  }
  try {
    if (location.pathname === cartPath) sessionStorage.removeItem(key);
  } catch (_) {}
  const remember = form => {
    if (!form || !form.querySelector('[name^="po_"], [po-btn-atc="true"]')) return;
    try {
      const action = new URL(form.action, location.href);
      if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
      sessionStorage.setItem(key, JSON.stringify({cartPath, source: location.pathname, time: Date.now()}));
    } catch (_) {}
  };
  document.addEventListener('submit', event => remember(event.target), true);
  document.addEventListener('click', event => {
    const button = event.target.closest('button[type="submit"], input[type="submit"], [data-add-to-cart]');
    if (button && !button.disabled) remember(button.form || button.closest('form'));
  }, true);
})();
